<template>
  <instant-product-search-input @product-selected="addProductToCollection" />
</template>

<script setup lang="ts">
import useAddToCollection from '@/modules/collection/useAddToCollection'
import InstantProductSearchInput from '@/modules/search/components/InstantProductSearchInput.vue'
import CollectionEvent from '@/modules/tracking/events/collection'
import { trackEvent } from '@/modules/tracking/useTracking'
import { DetailedShopCollection, ShopCollection } from '@/types/index'
import { PropType } from 'vue'

const props = defineProps({
  collection: {
    type: Object as PropType<ShopCollection | DetailedShopCollection | undefined>,
    required: true
  }
})

const addProductToCollection = (productId: number) => {
  useAddToCollection().addToCollection(props.collection!.id, productId)
  trackEvent(CollectionEvent.AddProduct)
}
</script>
